/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CommonService } from './services/common.service';
import { IdentityService } from './services/identity.service';
import { GrantService } from './services/grant.service';
import { UserRoleService } from './services/user-role.service';
import { RegistryService } from './services/registry.service';
import { MediaService } from './services/media.service';
import { NotificationService } from './services/notification.service';
import { CommunityService } from './services/community.service';
import { CountryService } from './services/country.service';
import { TravelService } from './services/travel.service';
import { BookingService } from './services/booking.service';
import { AddressBookService } from './services/address-book.service';
import { InvitationService } from './services/invitation.service';
import { InvoicingService } from './services/invoicing.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CommonService,
    IdentityService,
    GrantService,
    UserRoleService,
    RegistryService,
    MediaService,
    NotificationService,
    CommunityService,
    CountryService,
    TravelService,
    BookingService,
    AddressBookService,
    InvitationService,
    InvoicingService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
